export default {
    url: '/list',
    template: '<user-competence-competence-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/competence/list/index.js